export const isPrintableCharacter = (keyCode: string): boolean => {
    return keyCode.length === 1;
};
